/**
 * 医師オプション定数定義
 * バックエンドの値と同期させる必要があります
 */

import type { AvailableTask, AvailableLanguage } from '../types/doctor';

/**
 * 対応可能業務のマスターデータ
 * バックエンドの supported_services の値に対応
 */
export const AVAILABLE_SERVICES: AvailableTask[] = [
  { id: 1, name: 'ピル処方', value: 'pill' },
  { id: 2, name: '一般診療', value: 'consultation' },
  { id: 3, name: 'オンライン診療', value: 'online' }
];

/**
 * 対応可能言語のマスターデータ
 * バックエンドの supported_languages の値に対応
 */
export const AVAILABLE_LANGUAGES: AvailableLanguage[] = [
  { id: 1, name: '日本語', value: 'japanese' },
  { id: 2, name: '英語', value: 'english' }
];

/**
 * サービスの値から表示名を取得
 */
export const getServiceName = (value: string): string => {
  const service = AVAILABLE_SERVICES.find(s => s.value === value);
  return service?.name || value;
};

/**
 * 言語の値から表示名を取得
 */
export const getLanguageName = (value: string): string => {
  const language = AVAILABLE_LANGUAGES.find(l => l.value === value);
  return language?.name || value;
};

/**
 * サービスの値の配列から AvailableTask の配列に変換
 */
export const servicesToTasks = (services: string[]): AvailableTask[] => {
  return services
    .map(service => AVAILABLE_SERVICES.find(s => s.value === service))
    .filter((task): task is AvailableTask => task !== undefined);
};

/**
 * 言語の値の配列から AvailableLanguage の配列に変換
 */
export const languagesToAvailableLanguages = (languages: string[]): AvailableLanguage[] => {
  return languages
    .map(language => AVAILABLE_LANGUAGES.find(l => l.value === language))
    .filter((lang): lang is AvailableLanguage => lang !== undefined);
};

/**
 * AvailableTask の配列からサービスの値の配列に変換
 */
export const tasksToServices = (tasks: AvailableTask[]): string[] => {
  return tasks.map(task => task.value);
};

/**
 * AvailableLanguage の配列から言語の値の配列に変換
 */
export const availableLanguagesToLanguages = (languages: AvailableLanguage[]): string[] => {
  return languages.map(lang => lang.value);
};